import { ICertificateReducer, ICertificate } from 'models/Certificate'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray, deleteFromArray } from 'helpers/helperFunctions'
import {
  GetCertificates,
  CertificatesFetching,
  UpdateCertificate,
  DeleteCertificate,
  AddCertificate,
} from './actions'

const initialState: ICertificateReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const certificatesReducer = (state = initialState, action: Action): ICertificateReducer => {
  if (isType(action, GetCertificates)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, AddCertificate)) {
    const { payload } = action
    const { data } = state
    const newArray = [payload.data, ...data]
    return {
      ...state,
      data: newArray,
    }
  }
  if (isType(action, UpdateCertificate)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<ICertificate>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteCertificate)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<ICertificate>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, CertificatesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
